import { Callback } from "helix-vue-components";
import { Component, Prop, Vue } from "vue-property-decorator";
import Template from "./loadingModal.template.vue";

@Component({
  mixins: [Template]
})
export default class LoadingModal extends Vue {
  @Prop({ required: true })
  public msgModal!: string;
  @Prop({ required: true })
  public run!: Callback;

  public created() {
    this.doTask();
  }

  private async doTask() {
    const result = await this.run();
    this.$emit("resolve", result);
  }
}
